// stakingTabs.js
export const STAKING_TABS = {
  ASSET: "asset",
  BLOCKCHAIN: "blockchain",
  STAKING_PLATFORM: "stakingPlatform",
  VALIDATOR: "validator",
  STAKING_MECHANISM: "stakingMechanism",
  SLASHING: "slashing",
  LIQUIDITY: "liquidity",
  STAKED_VALUE: "stakedValue",
  TVL: "tvl",
  STAKING_BY_COMPETITORS: "stakingByCompetitors",
  STAKING_PROCEDURE: "stakingProcedure",
  SIMPLE: "simple",
};

export const DEFAULT_TAB = STAKING_TABS.ASSET;

export const TAB_CONFIG = [
  {
    key: STAKING_TABS.ASSET,
    component: "assetBlockchain",
    isAsset: true,
  },
  {
    key: STAKING_TABS.BLOCKCHAIN,
    component: "assetBlockchain",
    isAsset: false,
  },
  {
    key: STAKING_TABS.STAKING_PLATFORM,
    component: "platformValidator",
    isPlatform: true,
  },
  {
    key: STAKING_TABS.VALIDATOR,
    component: "platformValidator",
    isPlatform: false,
  },
  {
    key: STAKING_TABS.STAKING_MECHANISM,
    component: "simple",
    title: "Staking Mechanism Assessment",
    mainParameterName: "stakingMechanism",
    mainParameterLabel: "Staking Mechanism Risk",
  },
  {
    key: STAKING_TABS.SLASHING,
    component: "simple",
    title: "Slashing Assessment",
    mainParameterName: "slashing",
    mainParameterLabel: "Slashing Risk",
  },
  {
    key: STAKING_TABS.LIQUIDITY,
    component: "simple",
    title: "Liquidity Assessment",
    mainParameterName: "liquidity",
    mainParameterLabel: "Liquidity Risk",
  },
  {
    key: STAKING_TABS.STAKED_VALUE,
    component: "simple",
    title: "Staked Value Assessment",
    mainParameterName: "stakedValue",
    mainParameterLabel: "Staked Value Risk",
    hasAmountField: true,
    amountParameterName: "stakedValue",
    amountParameterLabel: "Staked Amount",
  },
  {
    key: STAKING_TABS.TVL,
    component: "simple",
    title: "TVL Assessment",
    mainParameterName: "tvl",
    mainParameterLabel: "TVL Risk",
  },
  {
    key: STAKING_TABS.STAKING_BY_COMPETITORS,
    component: "simple",
    title: "Staking by Competitors Assessment",
    mainParameterName: "stakingByCompetitors",
    mainParameterLabel: "Competitors Risk",
  },
  {
    key: STAKING_TABS.STAKING_PROCEDURE,
    component: "simple",
    title: "Staking Procedure Assessment",
    mainParameterName: "stakingProcedure",
    mainParameterLabel: "Procedure Risk",
  },
  {
    key: "simple",
    component: "simple",
    title: "",
    // mainParameterName: "stakingProcedure",
    // mainParameterLabel: "Procedure Risk",
  },
];
